import StepsBar from "./steps-bar";

export default StepsBar;
